import React, {forwardRef} from 'react';
import styled from "styled-components";
import IconSearchUi from "../../../../shared/ui/icons/icon-search.ui";
import {useProductSearchStore} from "../../model/store";
import AutocompleteInput from "./AutocompleteInput";
import {useSearch} from "../../model/useSearch";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

const StyledSearch = styled.div`
    overflow: hidden;
    border: 1px solid;
    display: flex;
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('search', 'border-radius')}, ${({theme}) => theme.search.borderRadius});
    border-color: var(${GLOBAL_STYLE_CONFIG.variable('search', 'border-color')}, ${({theme}) => theme.search.borderColor});
    background-color: var(${GLOBAL_STYLE_CONFIG.variable('search', 'bg-color')}, ${({theme}) => theme.search.bgColor});

`

const StyledSearchIcon = styled.div`
    height: inherit;
    padding: 0 9px;
    display: flex;
    align-items: center;
    background-color: ${props => props.theme.colors.primary};
`

interface IProps {
    ref?: React.RefObject<HTMLDivElement | null>;

}

const Search: React.FC<IProps> = forwardRef((_, ref) => {
    const {search, filter} = useProductSearchStore();
    const {fetchingSearch} = useSearch();

    const getProductsBySearch = (searchTerm: string) => {
        fetchingSearch({searchTerm, startIndex: 0, filterState:filter.state});
    }

    return (
        <StyledSearch className={GLOBAL_STYLE_CONFIG.splitByPrefix('search')} ref={ref}>
            <AutocompleteInput token={search.token} suggest={search.suggest}
                               getProductsBySearch={getProductsBySearch}
            />
            <StyledSearchIcon className={GLOBAL_STYLE_CONFIG.splitByPrefix('search-btn')}><IconSearchUi/></StyledSearchIcon>
        </StyledSearch>
    );
});

export default Search;